<template>
  <div>
    <md-empty-state :md-icon="require('../assets/calc.svg')" :md-label="$t('KiraFanCalc')">
      <p v-html="$t('Introduction')"></p>
      <p v-html="$t('GitLab')"></p>
      <p v-html="$t('Projects')" class="md-title"></p>
      <p v-html="$t('KiraFan Wiki')"></p>
      <p v-html="$t('Contact')" class="md-title"></p>
      <p v-html="$t('Circle Lin')"></p>
    </md-empty-state>
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      array: []
    };
  }
};
</script>

<style>
</style>
